<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Users</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>
        <m-confirm ref="confirm"></m-confirm>
        <m-user-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-user-form>
        <m-user-edit-form :user="selectedItem" :form="form" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-user-edit-form>


        <v-card style="max-width:100%; position:relative">

          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :options.sync="options"
              :sort-by="['id']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" :class="{'error-item' :  inValidItem(item)}">
              <td >{{ item.id }}</td>
              <td >{{ item.firstname }}</td>
              <td >{{ item.lastname }}</td>
              <td >{{ item.address }}</td>
              <td >{{ item.zip }}</td>
              <td >{{ item.city }}</td>
              <td >{{ item.birthday }}</td>
              <td >{{ item.tel }}</td>
              <td >{{ item.mobile }}</td>
              <td >{{ item.role }}</td>
              <td >{{ item.car }}</td>
              <td >{{ item.zones }}</td>
              <td >{{ item.email }}</td>
              <td >{{ item.client_from }}</td>
                <td>
                  <div style="display: flex">
                <v-btn icon class="mx-0" @click.stop="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import Confirm from '../../components/confirm.vue'
  import UserForm from '../../components/user/form.vue'
  import UserEditForm from '@/components/user/edit.vue'

  export default {
    components: {
      'm-confirm': Confirm,
      'm-user-form': UserForm,
      'm-user-edit-form': UserEditForm
    },
    data () {
      return {
        form: {},
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        search: '',
        options: {},
        selectedItem: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            value: 'id'
          },
          { text: 'Firstname', value: 'firstname' },
          { text: 'Lastname', value: 'lastname' },
          { text: 'Address', value: 'address' },
          { text: 'Zip', value: 'zip' },
          { text: 'City', value: 'city' },
          { text: 'Birthday', value: 'birthday' },
          { text: 'Tel', value: 'tel' },
          { text: 'Mobile', value: 'mobile' },
          { text: 'Role', value: 'role' },
          { text: 'Car', value: 'car' },
          { text: 'Zones', value: 'zones' },
          { text: 'Email', value: 'email' },
          { text: 'Client from', value: 'client_from' },
          { text: 'Action', value: 'action' }
        ],
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onSave (data) {
        console.log('save2', data);
        this.sendForm(data);
        this.dialog = false;
      },
      onClose () {
        this.dialog = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      onUpdate (data) {
        console.log('update user: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getData();
      },
      inValidItem (item) {
        return !item.fullAddress;
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/user', data)
        .then(response => {
          console.log('response data', response.data);
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        // var app = this;
        var id = this.selectedItem.id;
        this.$http
        .put('api/user/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          // this.reset();
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$refs.confirm.open('Delete', item.firstname + ' ' + item.lastname + ' ?').then((confirm) => {
          if (confirm) {
            this.$http
            .delete('api/user/' + item.id)
            .then(response => {
              console.log('user deleted', response.data);
              this.getData();
            })
            .catch(function (error) {
              console.log('catch:', error);
            });
          }
        });
      },
      getData () {
        var app = this;
        this.$http
        .get('api/user')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
    }
  }
</script>











